import fetch from './lib/fetch'

export async function getNavigation() {
  return await fetch(`${import.meta.env.VITE_API_URL}/navigation`)
}
